import Api from '../_redux/actions/api/_base';

export const sendSmsPharmaceutical = async (orderId, pharmaceuticalCode) => {
	const payload = {
		pharmaceuticalCode
	};
	const response = await Api.post(`/orders/${orderId}/sendSms`, payload, true);

	return response;
};

export const getOrderPharmaceutical = async orderIdCrypted => {
	const payload = {
		orderIdCrypted
	};
	const response = await Api.post(`/orders/pharmaceutical`, payload, true);
	
	if (response.data.statusCode == 200) {
		return response.data.content;
	}
	
	return response.data;
};
